import { InvitableOnsiteInterviewAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import {
  IGetInvitableOnsiteInterviewsPayload,
  IGetInvitableOnsiteInterviewsResult,
} from '../types';

export const getInvitableOnsiteInterviews = async (
  payload: IGetInvitableOnsiteInterviewsPayload,
): Promise<IGetInvitableOnsiteInterviewsResult> => {
  const response = await PermanentJobsApi.getInvitableOnsiteInterviews(payload);
  return InvitableOnsiteInterviewAdapters.toGetInvitableOnsiteInterviewsResult(response);
};
